import { useSelector } from "react-redux";

export const select_lang = () =>
{
    let opc = useSelector(state => state.selection.lang);
    let messages={};
    switch(opc){
        case 'es':
             messages = {
                "of":"de",
                "search":"Buscar...",
                "search2":"Buscar",
                "all": "Todo",
                "email":"La información solicitada se enviará al siguiente correo electrónico:",
                "example":"Ejemplo: usuario@example-com...",
                "close":"Cerrar",
                "clear":"Limpiar",
                "send":"Enviar",
                "download":"Descargar",
                "descrpexport":"Exportar en:",
                "Excel":"Consulta las variables seleccionadas en formato Excel (XLSX).",
                "Csv":"Consulta las variables seleccionadas en formato Csv",
                "Iqy":"Consulta las variables seleccionadas en formato Iqy",
                "emailwrong":"Formato de correo inválido.",
                "request":"Tu solicitud se ha procesado correctamente.",
                "badrequest":"Ha ocurrido un problema al procesar su solicitud- Favor de intentarlo mas tarde-",
                "open":"Abrir",
                "see":"Consultar",
                "copylink":"Compartir",
                "copylinkdescr":"Copia y pega el vínculo en un correo electrónico o donde quieras compartirlo para que otros usuarios puedan verlo en internet.",
                "rows":"Filas",
                "columns":"Columnas",
                "numdata":"Número de datos seleccionados:",
                "descripCopylink":"Copia y pega el vínculo en un correo electrónico o donde quieras compartirlo para que otros usuarios puedan verlo en internet-",
                "copied":"Copiado",
                "copy":"Copiar",
                "notfoundparam":"No se encontraron parámetros para mostrar un tabulado.",
                "limited":"La presentación en pantalla esta limitada a ",
                "optiondownload":" celdas. Para ver toda la información, puedes descargarla en los formatos disponibles.",
                "selectonevar":"Selecciona un valor de la variable: ",
                "selectvar":"Seleccionar variables",
                "changevar":"Cambiar variables",
                "opctab":"Opciones del Tabulado",
                "opcsortvar":"Ordenar variables",
                "notfoundpath":"No se encontró una ruta tematica para los parametros dados.",
                "home":"Inicio",
                "programs":"Programas",
                "themes":"Temas",
                "opcPxq1":"No actualizar la consulta, mostrar los mismos periodos que los de la pantalla",
                "opcPxq2":"Todos los periodos",
                "opcPxq3":"Actualizar la consulta con un punto de inicio móvil y siempre el mismo número de periodos:",
                "btnLink":"Crear vínculo",
                "chart":"Gráfica",
                "ind":"Indicador",
                "area":"Área geográfica",
                "graph":"Graficar",
                "low": "Baja",
                "mod":"Moderada" ,
                "opcActualizacion":"Opciones de actualización: ",
                "tittleChart":" por área geográfica",
                "Export1":"Imprimir gráfica",
                "Export2":"Descargar PNG",
                "Export3":"Descargar JPEG",
                "Export4":"Descargar PDF",
                "Export5":"Descargar SVG",
                "Export6":"Imprimir y exportar",
                "Export7":"Exportar y descargar gráfica en formato",
                "CV":"Coeficiente de variación",
                "EST":"Estimación",
                "SE":"Error estándar",
                "LL":"Límite inferior",
                "UL":"Límite superior",
                "IDC":"Intervalo de confianza al",
                "at": "al",
                "mild":"Moderada",
                "rutaTem":"Ruta temática",
                "chartMenu":"Imprimir y exportar",
                "txtEst":" Ver estadísticos",
                "MostrarNotes":" Notas, Llamadas y Fuentes",
                "hideRowsEmpty": " Ocultar renglones vacíos ",
                "from": "Desde:",
                "to":"Hasta:"
                
            }
            break;
            case 'en':
                 messages = {
                     "of": "of",
                    "search":"Search...",
                    "search2":"Search",
                    "all":"All",
                    "email":"The requested information will be sent to the following email:",
                    "example":"Example: user@example-com...",
                    "close":"Close",
                    "clear":"Clear",
                    "send":"Send",
                    "download":"Download",
                    "descrpexport":"Export in:",
                    "Excel":"Check the selected variables in Excel format (XLSX).",
                    "Csv":"Check the selected variables in Csv format",
                    "Iqy": "Check the selected variables in Iqy format",
                    "emailwrong":"Invalid email format.",
                    "request":"Your request has been successfully processed-",
                    "badrequest":"There was a problem processing your request- Please try again later.",
                    "open":"Open",
                    "see":"Query",
                    "copylink":"Share",
                    "copylinkdescr":"Copy and paste the link in an email or wherever you want to share it so that other users can see it on the internet.",
                    "rows":"Rows",
                    "columns":"Columns",
                    "numdata":"Number of selected data:",
                    "descripCopylink":"Copy and paste the link in an email or wherever you want to share it so that other users can see it on the internet-",
                    "copied":"Copied",
                    "copy":"Copy",
                    "notfoundparam":"No parameters were found to display a tab.",
                    "limited":"The screen presentation is limited to ",
                    "optiondownload":" cells. To see all the information, you can download it in the available formats.",
                    "selectonevar":"Select a value of the variable: ",
                    "selectvar":"Select variables",
                    "changevar":"Change variables",
                    "opctab":"Tabulation Options",
                    "opcsortvar":"Order variables",
                    "notfoundpath":"No thematic path found for the given parameters.",
                    "home":"Home",
                    "programs":"Programs",
                    "themes":"Themes",
                    "opcPxq1":"Do not update the query, show the same periods as those on the screen",
                    "opcPxq2":"All Periods",
                    "opcPxq3":"Update the query with a moving start point and always the same number of periods:",
                    "btnLink":"Create link",
                    "chart":"Chart",
                    "ind":"Indicator",
                    "area":"Geographic area",
                    "graph":"Graph",
                    "low": "Low",
                    "mod":"Moderate" ,
                    "opcActualizacion":"Upgrade options: ",
                    "tittleChart":" by geographic area",
                    "Export1":"Print graph",
                    "Export2":"Download PNG",
                    "Export3":"Download JPEG",
                    "Export4":"Download PDF",
                    "Export5":"Download SVG",
                    "Export6":"Print and export",
                    "Export7":"Export and download graph in format ",
                    "CV":"Coefficient of variation",
                    "EST":"Estimate",
                    "SE":"Standar error",
                    "LL":"Lower limit",
                    "UL":"Upper limit",
                    "IDC":"Confidence interval at",
                    "at":"at",
                    "mild":"Mild",
                    "rutaTem":"Thematic route",
                    "chartMenu":"Print and export",
                    "txtEst":" See statistics",
                    "MostrarNotes":" Notes, Footnotes and Sources",
                    "hideRowsEmpty": " Hide empty rows ",
                    "from": "From:",
                    "to":"To:"

                
                }
                break;

    }
    return messages;
}